import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import WorkLaws from '../components/WorkLaws'

const WorkLawsPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <WorkLaws />
            </div>
          </main>
    )
}

export default WorkLawsPage